<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-home"> </span>
                <span class="mls"> lnr-home</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-apartment"> </span>
                <span class="mls"> lnr-apartment</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pencil"> </span>
                <span class="mls"> lnr-pencil</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-magic-wand"> </span>
                <span class="mls"> lnr-magic-wand</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-drop"> </span>
                <span class="mls"> lnr-drop</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-lighter"> </span>
                <span class="mls"> lnr-lighter</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-poop"> </span>
                <span class="mls"> lnr-poop</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-sun"> </span>
                <span class="mls"> lnr-sun</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-moon"> </span>
                <span class="mls"> lnr-moon</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cloud"> </span>
                <span class="mls"> lnr-cloud</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cloud-upload"> </span>
                <span class="mls"> lnr-cloud-upload</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cloud-download"> </span>
                <span class="mls"> lnr-cloud-download</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cloud-sync"> </span>
                <span class="mls"> lnr-cloud-sync</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cloud-check"> </span>
                <span class="mls"> lnr-cloud-check</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-database"> </span>
                <span class="mls"> lnr-database</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-lock"> </span>
                <span class="mls"> lnr-lock</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cog"> </span>
                <span class="mls"> lnr-cog</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-trash"> </span>
                <span class="mls"> lnr-trash</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-dice"> </span>
                <span class="mls"> lnr-dice</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-heart"> </span>
                <span class="mls"> lnr-heart</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-star"> </span>
                <span class="mls"> lnr-star</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-star-half"> </span>
                <span class="mls"> lnr-star-half</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-star-empty"> </span>
                <span class="mls"> lnr-star-empty</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-flag"> </span>
                <span class="mls"> lnr-flag</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-envelope"> </span>
                <span class="mls"> lnr-envelope</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-paperclip"> </span>
                <span class="mls"> lnr-paperclip</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-inbox"> </span>
                <span class="mls"> lnr-inbox</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-eye"> </span>
                <span class="mls"> lnr-eye</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-printer"> </span>
                <span class="mls"> lnr-printer</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-file-empty"> </span>
                <span class="mls"> lnr-file-empty</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-file-add"> </span>
                <span class="mls"> lnr-file-add</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-enter"> </span>
                <span class="mls"> lnr-enter</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-exit"> </span>
                <span class="mls"> lnr-exit</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-graduation-hat"> </span>
                <span class="mls"> lnr-graduation-hat</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-license"> </span>
                <span class="mls"> lnr-license</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-music-note"> </span>
                <span class="mls"> lnr-music-note</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-film-play"> </span>
                <span class="mls"> lnr-film-play</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-camera-video"> </span>
                <span class="mls"> lnr-camera-video</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-camera"> </span>
                <span class="mls"> lnr-camera</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-picture"> </span>
                <span class="mls"> lnr-picture</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-book"> </span>
                <span class="mls"> lnr-book</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bookmark"> </span>
                <span class="mls"> lnr-bookmark</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-user"> </span>
                <span class="mls"> lnr-user</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-users"> </span>
                <span class="mls"> lnr-users</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-shirt"> </span>
                <span class="mls"> lnr-shirt</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-store"> </span>
                <span class="mls"> lnr-store</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cart"> </span>
                <span class="mls"> lnr-cart</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-tag"> </span>
                <span class="mls"> lnr-tag</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-phone-handset"> </span>
                <span class="mls"> lnr-phone-handset</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-phone"> </span>
                <span class="mls"> lnr-phone</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pushpin"> </span>
                <span class="mls"> lnr-pushpin</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-map-marker"> </span>
                <span class="mls"> lnr-map-marker</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-map"> </span>
                <span class="mls"> lnr-map</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-location"> </span>
                <span class="mls"> lnr-location</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-calendar-full"> </span>
                <span class="mls"> lnr-calendar-full</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-keyboard"> </span>
                <span class="mls"> lnr-keyboard</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-spell-check"> </span>
                <span class="mls"> lnr-spell-check</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-screen"> </span>
                <span class="mls"> lnr-screen</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-smartphone"> </span>
                <span class="mls"> lnr-smartphone</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-tablet"> </span>
                <span class="mls"> lnr-tablet</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-laptop"> </span>
                <span class="mls"> lnr-laptop</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-laptop-phone"> </span>
                <span class="mls"> lnr-laptop-phone</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-power-switch"> </span>
                <span class="mls"> lnr-power-switch</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bubble"> </span>
                <span class="mls"> lnr-bubble</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-heart-pulse"> </span>
                <span class="mls"> lnr-heart-pulse</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-construction"> </span>
                <span class="mls"> lnr-construction</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pie-chart"> </span>
                <span class="mls"> lnr-pie-chart</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chart-bars"> </span>
                <span class="mls"> lnr-chart-bars</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-gift"> </span>
                <span class="mls"> lnr-gift</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-diamond"> </span>
                <span class="mls"> lnr-diamond</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-linearicons"> </span>
                <span class="mls"> lnr-linearicons</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-dinner"> </span>
                <span class="mls"> lnr-dinner</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-coffee-cup"> </span>
                <span class="mls"> lnr-coffee-cup</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-leaf"> </span>
                <span class="mls"> lnr-leaf</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-paw"> </span>
                <span class="mls"> lnr-paw</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-rocket"> </span>
                <span class="mls"> lnr-rocket</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-briefcase"> </span>
                <span class="mls"> lnr-briefcase</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bus"> </span>
                <span class="mls"> lnr-bus</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-car"> </span>
                <span class="mls"> lnr-car</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-train"> </span>
                <span class="mls"> lnr-train</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bicycle"> </span>
                <span class="mls"> lnr-bicycle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-wheelchair"> </span>
                <span class="mls"> lnr-wheelchair</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-select"> </span>
                <span class="mls"> lnr-select</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-earth"> </span>
                <span class="mls"> lnr-earth</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-smile"> </span>
                <span class="mls"> lnr-smile</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-sad"> </span>
                <span class="mls"> lnr-sad</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-neutral"> </span>
                <span class="mls"> lnr-neutral</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-mustache"> </span>
                <span class="mls"> lnr-mustache</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-alarm"> </span>
                <span class="mls"> lnr-alarm</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bullhorn"> </span>
                <span class="mls"> lnr-bullhorn</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-volume-high"> </span>
                <span class="mls"> lnr-volume-high</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-volume-medium"> </span>
                <span class="mls"> lnr-volume-medium</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-volume-low"> </span>
                <span class="mls"> lnr-volume-low</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-volume"> </span>
                <span class="mls"> lnr-volume</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-mic"> </span>
                <span class="mls"> lnr-mic</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-hourglass"> </span>
                <span class="mls"> lnr-hourglass</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-undo"> </span>
                <span class="mls"> lnr-undo</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-redo"> </span>
                <span class="mls"> lnr-redo</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-sync"> </span>
                <span class="mls"> lnr-sync</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-history"> </span>
                <span class="mls"> lnr-history</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-clock"> </span>
                <span class="mls"> lnr-clock</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-download"> </span>
                <span class="mls"> lnr-download</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-upload"> </span>
                <span class="mls"> lnr-upload</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-enter-down"> </span>
                <span class="mls"> lnr-enter-down</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-exit-up"> </span>
                <span class="mls"> lnr-exit-up</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bug"> </span>
                <span class="mls"> lnr-bug</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-code"> </span>
                <span class="mls"> lnr-code</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-link"> </span>
                <span class="mls"> lnr-link</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-unlink"> </span>
                <span class="mls"> lnr-unlink</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-thumbs-up"> </span>
                <span class="mls"> lnr-thumbs-up</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-thumbs-down"> </span>
                <span class="mls"> lnr-thumbs-down</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-magnifier"> </span>
                <span class="mls"> lnr-magnifier</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cross"> </span>
                <span class="mls"> lnr-cross</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-menu"> </span>
                <span class="mls"> lnr-menu</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-list"> </span>
                <span class="mls"> lnr-list</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-up"> </span>
                <span class="mls"> lnr-chevron-up</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-down"> </span>
                <span class="mls"> lnr-chevron-down</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-left"> </span>
                <span class="mls"> lnr-chevron-left</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-right"> </span>
                <span class="mls"> lnr-chevron-right</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-up"> </span>
                <span class="mls"> lnr-arrow-up</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-down"> </span>
                <span class="mls"> lnr-arrow-down</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-left"> </span>
                <span class="mls"> lnr-arrow-left</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-right"> </span>
                <span class="mls"> lnr-arrow-right</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-move"> </span>
                <span class="mls"> lnr-move</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-warning"> </span>
                <span class="mls"> lnr-warning</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-question-circle"> </span>
                <span class="mls"> lnr-question-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-menu-circle"> </span>
                <span class="mls"> lnr-menu-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-checkmark-circle"> </span>
                <span class="mls"> lnr-checkmark-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-cross-circle"> </span>
                <span class="mls"> lnr-cross-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-plus-circle"> </span>
                <span class="mls"> lnr-plus-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-circle-minus"> </span>
                <span class="mls"> lnr-circle-minus</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-up-circle"> </span>
                <span class="mls"> lnr-arrow-up-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-down-circle"> </span>
                <span class="mls"> lnr-arrow-down-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-left-circle"> </span>
                <span class="mls"> lnr-arrow-left-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-arrow-right-circle"> </span>
                <span class="mls"> lnr-arrow-right-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-up-circle"> </span>
                <span class="mls"> lnr-chevron-up-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-down-circle"> </span>
                <span class="mls"> lnr-chevron-down-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-left-circle"> </span>
                <span class="mls"> lnr-chevron-left-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-chevron-right-circle"> </span>
                <span class="mls"> lnr-chevron-right-circle</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-crop"> </span>
                <span class="mls"> lnr-crop</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-frame-expand"> </span>
                <span class="mls"> lnr-frame-expand</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-frame-contract"> </span>
                <span class="mls"> lnr-frame-contract</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-layers"> </span>
                <span class="mls"> lnr-layers</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-funnel"> </span>
                <span class="mls"> lnr-funnel</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-format"> </span>
                <span class="mls"> lnr-text-format</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-format-remove"> </span>
                <span class="mls"> lnr-text-format-remove</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-size"> </span>
                <span class="mls"> lnr-text-size</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-bold"> </span>
                <span class="mls"> lnr-bold</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-italic"> </span>
                <span class="mls"> lnr-italic</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-underline"> </span>
                <span class="mls"> lnr-underline</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-strikethrough"> </span>
                <span class="mls"> lnr-strikethrough</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-highlight"> </span>
                <span class="mls"> lnr-highlight</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-align-left"> </span>
                <span class="mls"> lnr-text-align-left</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-align-center"> </span>
                <span class="mls"> lnr-text-align-center</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-align-right"> </span>
                <span class="mls"> lnr-text-align-right</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-text-align-justify"> </span>
                <span class="mls"> lnr-text-align-justify</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-line-spacing"> </span>
                <span class="mls"> lnr-line-spacing</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-indent-increase"> </span>
                <span class="mls"> lnr-indent-increase</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-indent-decrease"> </span>
                <span class="mls"> lnr-indent-decrease</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pilcrow"> </span>
                <span class="mls"> lnr-pilcrow</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-direction-ltr"> </span>
                <span class="mls"> lnr-direction-ltr</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-direction-rtl"> </span>
                <span class="mls"> lnr-direction-rtl</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-page-break"> </span>
                <span class="mls"> lnr-page-break</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-sort-alpha-asc"> </span>
                <span class="mls"> lnr-sort-alpha-asc</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-sort-amount-asc"> </span>
                <span class="mls"> lnr-sort-amount-asc</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-hand"> </span>
                <span class="mls"> lnr-hand</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pointer-up"> </span>
                <span class="mls"> lnr-pointer-up</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pointer-right"> </span>
                <span class="mls"> lnr-pointer-right</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pointer-down"> </span>
                <span class="mls"> lnr-pointer-down</span>
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="clearfix bshadow0 pbs">
                <span class="lnr lnr-pointer-left"> </span>
                <span class="mls"> lnr-pointer-left</span>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
